var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isLoading && 'spinner-container',attrs:{"role":"alert","aria-live":"assertive"}},[(_vm.isLoading)?_c('WCSpinner',{attrs:{"position":"window-center","size":"xl"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }